function WithContextProvider(Component, ContextProvider) {
  return function WithContextProviderComponent() {
    return (
      <ContextProvider>
        <Component />
      </ContextProvider>
    );
  };
}

export default WithContextProvider;
